<div class="profile-help-container" [ngClass]="rootClassName">
  <div class="profile-help-content headingboldlarge">
    <p>Help coming soon!</p>
    <div class="frame40pxspacer"></div>
  </div>
</div>
